import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '../../util';
import { useTranslation } from 'react-i18next';
import FolderBody from './FolderBody';
import generalRouteService from '../../services/general_route.service';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import fileUploadService from '../../util/files/file_upload.service';
import { uploadAllSelectedFiles } from '../../util/files/uppyGcpCustomImplementation';
import FileUploader from '../../util/files/FileUploader';
const CreateFolderOrFileModal = _ref => {
  let {
    route,
    show,
    onHide,
    allData,
    setAllData,
    currentFolderId,
    targetModelId,
    type
  } = _ref;
  const {
    t
  } = useTranslation();
  const [body, setBody] = useState({});
  const [uploadAllowed, setUploadAllowed] = useState(false);
  const [fileNotSelected, setFileNotSelected] = useState(false);
  const [uppyInstance, setUppyInstance] = useState(null);
  const [userIsEdittingFile, setUserIsEdittingFile] = useState(false);

  // these methods are wrapped here on purpose, so we dont rerender the uppy file uploader on every render
  const onUserEditFileStart = useCallback(() => setUserIsEdittingFile(true), []);
  const onUserEditFileEnd = useCallback(() => setUserIsEdittingFile(false), []);
  const getPresignedUrl = fileUploadService.useGetPresignedUrl();
  const createFolderFile = fileUploadService.useCreateFolderFile({
    onSuccess: error => console.log('Error: ', error),
    onError: () => {
      console.log('success');
    }
  });
  useEffect(() => {
    setBody({});
    if (!show) {
      setUploadAllowed(false);
    }
  }, [show]);
  const createFolder = useErrorHandling(useCallback(async () => {
    const payload = {
      name: body.name,
      parent_folder_id: currentFolderId,
      folderable_id: targetModelId,
      folderable_type: type
    };
    const response = await generalRouteService.create(route, payload);
    setAllData([...allData, response]);
  }, [body, currentFolderId, targetModelId, type, route, setAllData, allData]));
  const onSelectFile = useCallback(file => {
    // done so that onSelectFile does not both depend on the body, and set the body 
    setBody(body => {
      if (file?.name && !body.name) {
        return {
          ...body,
          'name': file.name.replace(/\.pdf$/, '')
        };
      } else {
        return body;
      }
    });
    if (file?.name) {
      setFileNotSelected(false);
    } else {
      setFileNotSelected(true);
    }
  }, []);
  const createFolderFileWithCloudFileRecord = useErrorHandling(useCallback(async (cloudFileRecord, uppyFileRecord) => {
    const payload = {
      name: uppyFileRecord.meta.name,
      // name will match the name the user set from the Uppy UI
      notes: uppyFileRecord.meta.notes,
      // notes will match the name the user set from the Uppy UI
      folder_id: currentFolderId,
      fileable_id: targetModelId,
      fileable_type: type
    };
    const response = await createFolderFile(payload, cloudFileRecord);
    setAllData([...allData, response]);
  }, [currentFolderId, targetModelId, type, createFolderFile, setAllData, allData]));
  const uploadFiles = useCallback(async () => {
    /** !!! TODO: This disabbles adding more files to the dialog while the upload is ongoing. This does not have to be disabled, as long as its implemented properly and the modal is not hidden on initial upload. */
    const currentFilesCount = uppyInstance.getFiles().length;
    uppyInstance.setOptions({
      restrictions: {
        maxNumberOfFiles: currentFilesCount
      }
    });
    await uploadAllSelectedFiles(uppyInstance, getPresignedUrl, createFolderFileWithCloudFileRecord);
  }, [createFolderFileWithCloudFileRecord, getPresignedUrl, uppyInstance]);
  const renderBody = route === 'folders' ? /*#__PURE__*/React.createElement(FolderBody, {
    body: body,
    setBody: setBody
  }) : /*#__PURE__*/React.createElement(FileUploader, {
    onSelectFile: onSelectFile,
    setUppyInstance: setUppyInstance,
    onUserEditFileStart: onUserEditFileStart,
    onUserEditFileEnd: onUserEditFileEnd
  });
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: route == 'folders' ? t('new_folder') : t('upload_file'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => route === 'folders' ? createFolder() : uploadFiles(),
    submitText: route === 'folders' ? t('create') : t('upload'),
    disabled: route !== 'folders' && (fileNotSelected || userIsEdittingFile)
  });
};
export default CreateFolderOrFileModal;